/* eslint-disable quotes */
import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import userDetail from 'Stores/userDetail';
import { Utils } from 'Utils/utils';
import pricingDataState from 'Stores/pricingData';
import Button from 'Components/common/Button';
import * as CONSTANTS from 'Utils/constants';
import LoadingWrapper from 'Components/common/loadingWrapper';
import CollapsiveContent from 'Components/common/CollapsiveContent';
import ToolTip from 'Components/common/ToolTip';
import ChatEmailImg from 'Assets/png/commonPricing/chat-email.png';
import ChatDriftImg from 'Assets/png/commonPricing/chat-drift.png';
import { ReactComponent as InfoIcon } from 'Assets/svg/info-filled-icon.svg';
import { ReactComponent as TickIcon } from 'Assets/svg/tick-icon-new.svg';
import { ReactComponent as ArrowIcon } from 'Assets/svg/right-arrow.svg';
import { ReactComponent as FocusArrowIcon } from 'Assets/svg/focus-arrow.svg';
import TrustedCompanyImg from 'Assets/png/payg_pricing/trusted-company-logo.png';
import G2ReviewBadgeImg from 'Assets/png/payg_pricing/g2-review-batch.png';
import FireImg from 'Assets/png/fire.png';
import G2ReviewCupImg from 'Assets/png/payg_pricing/g2-review-cup.png';
import QuotesImg from 'Assets/png/payg_pricing/quotes.png';
import G2LogoImg from 'Assets/png/payg_pricing/g2-logo.png';
import { confirmationPopupState } from 'Components/common/confirmationPopup';
import CommonPopupWithImageComponent from 'Components/common/commonPopupWithImageComponent';
import SuccessTickBgImg from 'Assets/png/successTickBg.png';
import { freeTrialPopupState } from 'Stores/freeTrialPopupState';
import { toasterState } from 'Components/common/toaster';
import { warningPopupState } from 'Components/common/commonWarningPopup';
import StripePayment from './StripePayment';

import '../../../styles/layout/_paygPricingPage.scss';

const EXISTING_PLAN_TYPES = {
  ENTERPRISE_TRIAL: 'ENTERPRISE_TRIAL',
  PAID: 'PAID',
  TRIAL: 'TRIAL',
  FREEMIUM: 'FREE',
};

const pricingAdditionalFeatureList = {
  FREE: [
    { labelText: 'Free Includes:', isTitle: true },
    {
      labelText: 'Access to Chrome Plugin',
    },
    {
      labelText: 'Access Web platform',
    },
    {
      labelText: 'Email Addresses',
    },
    {
      labelText: 'Company data',
      helpText:
        'Account intelligence data like revenue, location, size and more',
    },
    {
      labelText: 'Prospecting Filters',
    },
  ],
  STARTER: [
    { labelText: 'Everything in Free, plus:', isTitle: true },
    {
      labelText: 'Mobile Numbers',
    },
    {
      labelText: 'Export to CSV',
    },
    {
      labelText: 'Reveal more search results',
    },
    {
      labelText: 'Bulk export',
    },
    {
      labelText: 'List export',
    },
    {
      labelText: 'Alerts & Notifications',
      helpText:
        'Create alerts for your search. Get notified to discover new leads regularly.',
    },
    {
      labelText: 'Job Changes & Profile<br /> Updates',
      helpText:
        'Know when contacts in your list change jobs or update their profile.',
    },
  ],
  GROWTH: [
    { labelText: 'Everything in Starter, plus:', isTitle: true },
    {
      labelText: 'Export to CRM',
      helpText: 'Integrate your CRM to export data directly from Adapt',
    },
    {
      labelText: 'Technology data',
      helpText: 'Search based on tech stack used by prospects',
    },
  ],

  ENTERPRISE: [
    { labelText: 'Everything in Growth, plus:', isTitle: true },
    {
      labelText: 'Unlimited Credits*',
    },
    {
      labelText: 'Custom seat allocation',
    },
    {
      labelText: 'User management',
    },
    {
      labelText: 'Usage Analytics',
    },
    {
      labelText: 'CRM enrichment',
      helpText:
        'Ensure that your CRM data stays accurate and fresh all the time',
    },
    {
      labelText: 'Contact refresh sync (automatic)',
    },
    {
      labelText: 'Dedicated success manager',
    },
    {
      labelText: 'Suppression List',
      helpText: 'Exclude contacts you own from other sources',
    },
    {
      labelText: 'Adapt API',
      helpText: 'Integrate Adapt for data enrichment and verification',
    },
  ],
};

const g2ReviewList = [
  {
    title: 'Great for finding prospects to reach out to, very seamless.',
    description:
      'I like how adapt is very easy to use and provides trustworthy domains to reach out to prospects. It is the number one tool I use to find opportunities.',
    userName: 'Jaelyn G',
    role: 'Senior Account Director',
    companyName: 'SWNS',
  },
  {
    title: "I'm pleased with Adapt... great service!",
    description:
      "This has been a terrific service when I've been stumped on an email for a contact in LinkedIn! If there's ever a time when I cannot find the email another way, I would say 75% of the time I can get it from Adapt prospector.",
    userName: 'Julie Hundal',
    role: 'National Account Manager',
    companyName: 'Veolia UK',
  },
  {
    title: 'User Friendly and Super Efficient',
    description:
      'Very competitive pricing and user-friendly technology; minimal setup time and quick onboarding. The leads are very efficient and quality-focused, which enables me to focus on selling and closing more deals which is crucial.',
    userName: 'Esther S',
    role: 'Member',
    companyName: 'Rocktoberfest Planning Committee',
  },
  {
    title:
      'Absolutely useful took for sales & marketing professionals. almost accurate data.',
    description: 'Accurate data and information. Ease of use',
    userName: 'Gabriel K',
    role: 'Manager',
    companyName: 'Go-To Market Solutions',
  },
];

const TrustedUserSection = () => {
  return (
    <div className="trusted-user-section">
      <div className="title">Trusted by 500K+ Users</div>
      <img src={TrustedCompanyImg} alt="trusted-company-logo" />
    </div>
  );
};

const G2ReviewSection = () => {
  return (
    <>
      <div className="g2-review-wrapper">
        <div className="title">Don’t just take our word for it</div>
      </div>
      <div className="g2-review-list-wrapper">
        <div className="g2-review-list">
          {g2ReviewList.map((item, index) => {
            const { title, description, userName, role, companyName } = item;
            return (
              <div className="g2-review-item" key={`g2-review-item${index}`}>
                <img src={G2LogoImg} alt="g2-logo" className="g2-logo" />
                <img src={QuotesImg} alt="quotes" className="double-quotes" />
                <div className="review-title">
                  “<span>{title}</span>”
                </div>
                <div className="description">{description}</div>
                <div className="user-name">{userName}</div>
                <div className="role">
                  {role}, <span className="company-name">{companyName}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

const G2BadgeSection = () => {
  return (
    <div className="g2-badge-wrapper">
      <div className="left-wrapper">
        <img src={G2ReviewCupImg} alt="g2-review-cup" />
      </div>
      <div className="right-wrapper">
        <div className="title">Consistent Performer on G2</div>
        <img src={G2ReviewBadgeImg} alt="g2-review-badge" />
      </div>
    </div>
  );
};

const isEnterprisePlan = (planName = '') => {
  return planName === 'ENTERPRISE';
};
const isFreePlan = (planName = '') => {
  return planName === 'FREE';
};
const isGrowthPlan = (planName = '') => {
  return planName === 'GROWTH';
};

const isFreeTrialPlanActive = (planType = '', planName = '') => {
  if (planType === EXISTING_PLAN_TYPES.FREEMIUM && isFreePlan(planName))
    return true;
  return false;
};

const PlanListCard = observer(props => {
  const { buyNowCbk = () => {}, existingPlanType = '' } = props;
  const { subscriptionPlans = [] } = userDetail;
  const [freemiumTrialApiLoading, setFreemiumTrialApiLoading] = useState(false);
  const [
    enterpriseInterestApiLoading,
    setEnterpriseInterestApiLoading,
  ] = useState(false);

  const handleFreePlanClick = (isPlanActive, selectedPlan) => {
    if (!isPlanActive) {
      setFreemiumTrialApiLoading(true);
      if (!freemiumTrialApiLoading) {
        const callback = res => {
          if (res?.data?.status && res?.data?.status === 'true') {
            toasterState.setToastMsg(
              'Free plan activated successfully. Happy Prospecting!',
              'success',
            );
            setTimeout(() => {
              Utils.refreshPage();
            }, 700);
          } else {
            let { message } = res.data;
            if (message === 'freemium_domain_limit_exceeded') {
              const messageStr = (
                <>
                  This domain has registered multiple accounts with us. Please
                  write to{' '}
                  <a href="mailto:support@adapt.io">support@adapt.io</a> forts
                  manual activation of your plan.
                </>
              );
              warningPopupState.setShowPopup({
                className: 'monthly-limit',
                title: '',
                message: messageStr,
              });
            } else if (message === null || message === undefined) {
              message = 'Something went wrong, please try again later';
              toasterState.setToastMsg(message, 'failure');
            }

            setFreemiumTrialApiLoading(false);
          }
        };
        pricingDataState.freemiumPlanRequest(selectedPlan, false, callback);
      }
    }
  };

  const handleEnterprisePlanClick = () => {
    setEnterpriseInterestApiLoading(true);
    if (!enterpriseInterestApiLoading) {
      Utils.mixpanelTrack(
        CONSTANTS.MX_PRICING_PAGE.CLICK_LB_PRICING_TALK_TO_US,
        {},
      );
      Utils.mixpanelUpdateProfileProperty({
        [CONSTANTS.MX_PROFILE_PROPERTIES.ENTERPRISE_PLAN_REQUEST]: true,
      });
      const callback = () => {
        setEnterpriseInterestApiLoading(false);
      };
      Utils.enterprisePlanInterestNotification('CUSTOM_PRICING', callback);
    }
  };

  return (
    <div className="pricing-cards">
      {subscriptionPlans.map((item, index) => {
        const {
          name,
          displayName,
          annualPrice,
          price,
          lbCredits,
          phoneCredits,
          phonePricePerContact = 0.9,
          pricePerContact,
          actualAnnualPrice = 0,
          offerPercentage = 0,
        } = item;

        const isPlanActive = isFreeTrialPlanActive(existingPlanType, name);
        return (
          <div
            className={`plan-card ${name.toLowerCase()}-plan-card ${
              isPlanActive ? 'current-plan-card' : ''
            }`}
            key={`plan-list${index}`}
          >
            <div className="most-popular">
              <img src={FireImg} alt="FireImg" /> Most Popular
            </div>

            <div className="plan-card-wrapper">
              {offerPercentage !== null && offerPercentage > 0 && (
                <span className="offer">{`${offerPercentage}% OFF`}</span>
              )}
              <TickIcon className="tick-icon current-plan-tick" />
              <div className="pricing-info-section">
                <div className="plan-name">{displayName}</div>
                <div className="pricing-info">
                  {isEnterprisePlan(name) ? (
                    'Custom'
                  ) : actualAnnualPrice > 0 ? (
                    <>
                      <del>
                        ${Utils.viewsDownloadsNumberFormat(actualAnnualPrice)}
                      </del>{' '}
                      $
                      {Utils.viewsDownloadsNumberFormat(Math.ceil(annualPrice))}{' '}
                      <span className="sub-text">/ annual</span>
                    </>
                  ) : (
                    <>
                      ${Utils.viewsDownloadsNumberFormat(price)}{' '}
                      <span className="sub-text">/ month</span>
                    </>
                  )}
                </div>
                <div className="billed-annually">*Billed annually</div>
                <div className="price-per-credit">
                  (${pricePerContact} per credit)
                </div>
              </div>
              <div className="credit-info-section">
                <div className="credit-info-wrapper">
                  {isFreePlan(name) ? (
                    <>
                      <div className="credit-detail">
                        {Utils.viewsDownloadsNumberFormat(lbCredits)} email
                        credits
                        <span className="sub-text">/month</span>
                      </div>
                      <div className="credit-provide-detail">
                        Unused credits don&apos;t rollover
                      </div>
                    </>
                  ) : isEnterprisePlan(name) ? (
                    <>
                      <div className="credit-provide-detail">
                        Contact Sales for custom pricing
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="credit-detail">
                        {Utils.viewsDownloadsNumberFormat(lbCredits)} email
                        credits
                        <span className="sub-text">/year</span>
                      </div>
                      <div className="credit-provide-detail">
                        Credits provided upfront
                      </div>
                      <div className="additional-credit-detail">
                        {`Additional email credits at $${pricePerContact}`}
                      </div>
                      <div className="credit-detail phone-credits">
                        {Utils.viewsDownloadsNumberFormat(phoneCredits)} phone
                        credits
                        <span className="sub-text">/year</span>
                      </div>
                      <div className="credit-provide-detail">
                        Credits provided upfront
                      </div>
                      <div className="additional-credit-detail">
                        {`Additional phone credits at $${phonePricePerContact}`}
                      </div>
                    </>
                  )}
                </div>

                <div className="btn-section">
                  {isFreePlan(name) ? (
                    <Button
                      id="buyNow"
                      btnText={isPlanActive ? 'Current Plan' : 'Upgrade Now'}
                      type="button"
                      className={`action-btn ${
                        freemiumTrialApiLoading ? ' loading' : ''
                      }`}
                      loader={freemiumTrialApiLoading}
                      click={e => handleFreePlanClick(isPlanActive, item)}
                      svg={
                        <ArrowIcon
                          className="arrow-right"
                          width={14}
                          height={18}
                        />
                      }
                    />
                  ) : isEnterprisePlan(name) ? (
                    <Button
                      id="buyNow"
                      btnText="Talk to Sales"
                      type="button"
                      className={`action-btn ${
                        enterpriseInterestApiLoading ? ' loading' : ''
                      }`}
                      loader={enterpriseInterestApiLoading}
                      click={e => handleEnterprisePlanClick()}
                      svg={
                        <ArrowIcon
                          className="arrow-right"
                          width={14}
                          height={18}
                        />
                      }
                    />
                  ) : (
                    <Button
                      id="buyNow"
                      btnText="Upgrade Now"
                      type="button"
                      className=""
                      click={e => buyNowCbk(item)}
                      svg={
                        <ArrowIcon
                          className="arrow-right"
                          width={14}
                          height={18}
                        />
                      }
                    />
                  )}
                </div>
              </div>
              <div className="features-info-section">
                {pricingAdditionalFeatureList?.[name]?.map(
                  (featureItem, featureIndex) => {
                    const {
                      labelText,
                      helpText = false,
                      isTitle,
                    } = featureItem;

                    return (
                      <div
                        className={`feature-info-item ${
                          isTitle ? 'title-wrap' : ''
                        }`}
                        key={`feature-item${featureIndex}`}
                      >
                        <TickIcon className="tick-icon" />
                        <div className="info-detail">
                          <span
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: labelText }}
                          />
                          {helpText && (
                            <div className="info-icon toolTipParentWrap">
                              <InfoIcon width={14} height={14} />
                              <ToolTip toolTipText={helpText} />
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  },
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
});

const ExistingPlanCard = observer(props => {
  const { featureFlags, currentSubscriptionPlanInfo = null } = userDetail;
  const { LEAD_BUILDER } = featureFlags;

  const {
    displayName,
    price,
    type,
    lbCredits,
    views,
    downloads,
    renewalDate,
    creditResetPeriod,
  } = currentSubscriptionPlanInfo;
  const renewalDateObj = new Date(renewalDate);
  return (
    <div className="pricing-section existing-plan-section">
      <div className="pricing-title">Plan and billing</div>

      <div className="plan-detail-card">
        <div className="plan-info">
          <div className="plan-heading">Current Plan</div>
          <span>{`${displayName} - ${price}`}</span>{' '}
          <span>{type === 0 ? ' / month' : ' / year'}</span>
        </div>
        <div className="credit-info-card">
          {Utils.isCreditBasedSubscription() ? (
            <div className="credits-detail">
              {Utils.viewsDownloadsNumberFormat(lbCredits)} credits{' '}
              {Utils.getCreditResetPeriodInString(type, creditResetPeriod)} -
              Chrome Extension {LEAD_BUILDER && ' & List Builder'} Access
            </div>
          ) : (
            <div className="credits-detail">
              {Utils.viewsDownloadsNumberFormat(views)} views and{' '}
              {Utils.viewsDownloadsNumberFormat(downloads)} downloads{' '}
              {Utils.getCreditResetPeriodInString(type, creditResetPeriod)} -
              Chrome Extension {LEAD_BUILDER && ' & List Builder'} Access
            </div>
          )}
          <div className="renewal-date">
            Next Renewal Date :{' '}
            <span>
              {`${renewalDateObj.toLocaleString('default', {
                month: 'long',
              })} ${renewalDateObj.getDate()}, ${renewalDateObj.getFullYear()}`}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
});

const ExistingPendingPlanCard = observer(props => {
  const { paymentPending } = userDetail.userInfo;
  const { isAnnual: isAnnualPlan = false, amount, planName } = paymentPending;
  return (
    <div className="pricing-section existing-plan-section existing-pending-plan-section">
      <div className="pricing-title">Plan and billing</div>

      <div className="plan-detail-card">
        <div className="plan-info">
          <div className="plan-heading">Current Plan</div>
          {planName} - ${amount}{' '}
          <span>{!isAnnualPlan ? ' / month' : ' / year'}</span>
        </div>
        <div className="credit-info-card">
          <div className="credits-detail">
            Your account is currently being setup. You will receive a
            confirmation from the Adapt team soon
          </div>
        </div>
      </div>
    </div>
  );
});

const PaygPricing = observer(props => {
  const {
    isAnnualSelected,
    showPaymentForm,
    showPaymentReviewPopup,
    showPaymentSuccessPopup,
  } = pricingDataState;

  const {
    subscriptionPlans = [],
    userInfo,
    currentSubscriptionPlanInfo = null,
    hubspotCalendarLink,
  } = userDetail;

  const [existingPlanType, setExistingPlanType] = useState('');

  const openPaymentForm = selectedPlanInfo => {
    const { name, annualPrice, price, version } = selectedPlanInfo;

    console.log('selectedPlanInfo ', selectedPlanInfo);

    const mxData = {
      selectedPlanType: name,
      isAnnual: isAnnualSelected,
      planAmount: isAnnualSelected ? annualPrice : price,
      version,
    };

    const {
      userStatus,
      email,
      memberSubscription,
      isEnterpriseAdmin,
      teamAdminEmail,
    } = userInfo;

    if (!isFreePlan(name))
      if (userStatus === 0) {
        Utils.hubspotEventPush(
          CONSTANTS.HUBSPOT_EVENTS.SELF_SERVE_BUY_NOW_CLICK,
          'true',
        );
        if (memberSubscription !== null && !isEnterpriseAdmin) {
          confirmationPopupState.setPopupValues({
            content: `<br />Please contact your account administrator <a href="mailto:${teamAdminEmail}">${teamAdminEmail}</a> to upgrade your subscription.`,
            actionBtnText: 'Ok',
            needCancelBtn: false,
            showCloseBtn: false,
            callback: () => {},
          });
          confirmationPopupState.setShowPopup(true);
        } else {
          Utils.mixpanelTrack(
            CONSTANTS.MX_PRICING_PAGE.CLICK_LB_PRICING_PLAN_SELECTED,
            mxData,
          );
          pricingDataState.setSelectedPlan(selectedPlanInfo);
          pricingDataState.setShowPaymentForm(true);
        }
      } else {
        Utils.showEmailConfirmationPopup(email);
      }
  };

  const closePaymentForm = () => {
    pricingDataState.setShowPaymentForm(false);
  };

  const enterpriseTrialChatClick = () => {
    Utils.mixpanelTrack(
      CONSTANTS.MX_PRICING_PAGE.CLICK_LB_PRICING_ENTERPRISE_TRIAL_TALK_TO_US,
      {},
    );
    window.open(hubspotCalendarLink, '_blank');
  };

  useEffect(() => {
    Utils.mixpanelTrack(CONSTANTS.MX_PRICING_PAGE.VIEW_LB_PRICING_PAGE, {});
    Utils.hubspotEventPush(
      CONSTANTS.HUBSPOT_EVENTS.SELF_SERVE_PAGE_VIEWED,
      'true',
    );
    // Utils.trackRefinerPricingPageViewed();
    if (Utils.isFreeTrialPlan())
      Utils.mixpanelUpdateProfileProperty({
        [CONSTANTS.MX_PROFILE_PROPERTIES.TAM_PRICING_VIEWED]: true,
      });
  }, []);

  useEffect(() => {
    if (Utils.isEnterpriseFreeTrialPlan()) {
      setExistingPlanType(EXISTING_PLAN_TYPES.ENTERPRISE_TRIAL);
    } else if (Utils.isFreeTrialPlan()) {
      setExistingPlanType(EXISTING_PLAN_TYPES.TRIAL);
    } else if (currentSubscriptionPlanInfo !== null) {
      const { name = '' } = currentSubscriptionPlanInfo;
      if (name && isFreePlan(name))
        setExistingPlanType(EXISTING_PLAN_TYPES.FREEMIUM);
      else if (currentSubscriptionPlanInfo !== null)
        setExistingPlanType(EXISTING_PLAN_TYPES.PAID);
      else setExistingPlanType('');
    } else {
      setExistingPlanType('');
    }
  }, [currentSubscriptionPlanInfo]);

  useEffect(() => {
    if (showPaymentForm && Utils.intlProps === null)
      Utils.initiateIntl(true, '#phoneNumber');
    else Utils.intlProps = null;
  }, [showPaymentForm]);

  const getTogglePlanType = value => {
    pricingDataState.setAnnualSelected(value);
  };

  const handleHoldSuccessOkClick = () => {
    Utils.refreshPage();
  };

  const handleCaptureSuccessOkClick = () => {
    Utils.redirectToLbHomePage();
  };

  return subscriptionPlans.length === 0 ? (
    <LoadingWrapper show position="fixed" />
  ) : (
    <div className="payg-pricing-component">
      {showPaymentReviewPopup && (
        <CommonPopupWithImageComponent
          ImgComponent={SuccessTickBgImg}
          titleText="Purchase Successful"
          description="Your prospecting mission is on! Our team will proceed to setup your account at the earliest and send you a confirmation. Happy Prospecting!"
          btnText="Ok"
          customParentClass="payment-hold-success-popup"
          actionBtnCallback={handleHoldSuccessOkClick}
          clickOutsidePopupCallback={handleHoldSuccessOkClick}
        />
      )}
      {showPaymentSuccessPopup && (
        <CommonPopupWithImageComponent
          ImgComponent={SuccessTickBgImg}
          titleText="Purchase Successful"
          description="Thank you for choosing Adapt. You are now a part of our 500K+
              prospector community. Happy Prospecting!"
          btnText="Ok"
          customParentClass="payment-hold-success-popup"
          actionBtnCallback={handleCaptureSuccessOkClick}
          clickOutsidePopupCallback={handleCaptureSuccessOkClick}
        />
      )}
      {Utils.isPaymentPendingReview() && <ExistingPendingPlanCard />}

      {existingPlanType === EXISTING_PLAN_TYPES.PAID &&
        !Utils.isPaymentPendingReview() && <ExistingPlanCard />}
      {(existingPlanType === '' ||
        existingPlanType === EXISTING_PLAN_TYPES.TRIAL ||
        existingPlanType === EXISTING_PLAN_TYPES.FREEMIUM) &&
        !Utils.isPaymentPendingReview() && (
          <div className="pricing-section">
            <div className="pricing-title">
              Data is simple. And so is our pricing
            </div>
            <div className="pricing-sub-description">
              Data subscriptions are unnecessarily complicated. At Adapt, we
              have uncomplicated B2B data to be more accessible and flexible.
              Our plans help you go to market faster and with more confidence.
            </div>

            <PlanListCard
              buyNowCbk={openPaymentForm}
              existingPlanType={existingPlanType}
            />

            {showPaymentForm && (
              <div className="payment-form-section">
                <div className="payment-section">
                  <div className="animated customzoomIn">
                    <StripePayment showPaymentForm={showPaymentForm} />
                  </div>
                </div>
                <div
                  className="overlay-payment-form"
                  onClick={closePaymentForm}
                />
              </div>
            )}
          </div>
        )}

      <div
        className={`chat-us-section ${existingPlanType === '' ? 'hide' : ''} ${
          existingPlanType === EXISTING_PLAN_TYPES.ENTERPRISE_TRIAL
            ? 'chat-us-enterprise-trial'
            : ''
        }`}
      >
        <div className="chat-us-wrapper">
          <span className="chat-dot-bg" />
          <div className="chat-content">
            <div className="chat-title">
              {existingPlanType === EXISTING_PLAN_TYPES.PAID ||
              existingPlanType === EXISTING_PLAN_TYPES.ENTERPRISE_TRIAL
                ? 'Looking to upgrade your plan?'
                : 'Looking for API / Enterprise plans?'}
            </div>
            <div className="chat-sub-title">
              or have any questions related to pricing?
            </div>
          </div>
          {existingPlanType === EXISTING_PLAN_TYPES.ENTERPRISE_TRIAL ? (
            <div className="chat-box " onClick={enterpriseTrialChatClick}>
              <img src={ChatDriftImg} alt="drift" />
              Talk to our sales representative
            </div>
          ) : (
            <>
              <div className="chat-box">
                <a
                  href={
                    existingPlanType === EXISTING_PLAN_TYPES.PAID
                      ? 'mailto:success@adapt.io'
                      : 'mailto:sales@adapt.io'
                  }
                >
                  <img src={ChatEmailImg} alt="email" />
                  <span>
                    {existingPlanType === EXISTING_PLAN_TYPES.PAID
                      ? 'success@adapt.io'
                      : 'sales@adapt.io'}
                  </span>
                </a>
              </div>
              <div className="chat-box">
                <a href="#pricingEnterpriseContact">
                  <img src={ChatDriftImg} alt="drift" />
                  Chat Now
                </a>
              </div>
            </>
          )}
        </div>
      </div>

      <TrustedUserSection />
      <G2ReviewSection />
      <G2BadgeSection />

      <div className="freqAskQuesSection">
        <h4 className="title">FAQs</h4>
        <div className="freqAskQuesRow">
          <div className="contentCol">
            {CONSTANTS.PAYG_PRICING_FREQ_ASK_QUESTIONS.map((item, index) => {
              return (
                <CollapsiveContent
                  key={`freqAskQuestion${index + 1}`}
                  title={item.title}
                  content={item.description}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
});

export { PaygPricing };
export default PaygPricing;
